import React, { useState, useEffect, useLayoutEffect, useRef, useContext } from 'react';
import Cookies from 'js-cookie'

import './CharNameMobile.css'

import { UserDataContext } from "../App.js";
import { DEFAULT_CAMPAIGN } from '../globals.js';
import LOAD_CHAR from './Charsheet0/helpers/load_char2.js';
import flatten from './Charsheet0/helpers/flatten.js';

// ----------------------------------------------------------------------------------
//                         Description
//
//     CharNameMobile is a bar that shows the character name and image
//
//     (c) DXA Development 2024
// ----------------------------------------------------------------------------------

const CharNameMobile = (props) => {

  // ------------ parameters ---------------

  // ------ inherited state variables ------
  const [userData, setUserData] = useContext(UserDataContext);

  const data = props.data;
  const setData = props.setdata || (() => {});
  var spellUpdaters = props.spellUpdaters;

  var currentChar = data.name || props.state[0];
  var setChar = props.state[1];

  // charID is used to ID the main div, which will be id="{charID}-div"
  const thisCharID = props.charID || '0';

  const toggleCollapse = props.toggleCollapse || (() => {});

  const handleNameClick = async () => {
    if (data.name === 'Load Character') {
      const charName = prompt("Load character:", "");
      if (!charName || charName.trim() === '') return;
      const result = await LOAD_CHAR(charName.trim(), setChar, false, userData, 'CharNameMobile');
      if (result.data && result.data !== 'User Cancelled') {
        setData(flatten(result.data));
      }
    } else {
      toggleCollapse();
    }
  };

  // -------- local state variables --------
  
  var [ charImage, setCharImage ] = useState( '' );
  const [ editing, setEditing ] = useState(false);
  const [ currentSpell, setCurrentSpell] = useState('Charmobile Knock');
  const [ currentSpellData, setCurrentSpellData ] = useState({});

  const [ displayName, setDisplayName ] = useState( data.name ? data.name : currentChar )

  const nameRef = useRef(null);

  useLayoutEffect(() => {
    const el = nameRef.current;
    if (!el) return;
    const MAX = 20;
    const MIN = 12;
    let size = MAX;
    el.style.fontSize = size + 'px';
    while (el.scrollWidth > el.clientWidth && size > MIN) {
      size -= 1;
      el.style.fontSize = size + 'px';
    }
  }, [displayName]);



  // -------- USE EFFECT  --------

  useEffect( () => {

    async function LoadCharacterImage () {
      console.log('CN User Data', userData )
        const campaign = userData.currentCampaign || DEFAULT_CAMPAIGN;
        setCharImage(process.env.PUBLIC_URL + `/img/char/${campaign}/${currentChar}.jpg?cb=${Math.random().toString(36).substring(2)}`);
        console.log('charname data:', data )
    }

    LoadCharacterImage();
    setDisplayName(data.name ? data.name : currentChar)

    console.log('CN Data', data)

}, [ currentChar, userData.currentCampaign, data ]) ; // END useEffect

  useEffect( () => {
    const handler = (e) => {
      if (!e.detail || e.detail.charName !== currentChar) return;
      setCharImage(e.detail.url);
    };
    window.addEventListener('charImageUpdated', handler);
    return () => window.removeEventListener('charImageUpdated', handler);
  }, [ currentChar ]);

  // -------- RETURN JSX --------

  return (

    <>
      <div className="charheader-mobile">

          <div class="charsummary-mobile">
              <div class="charname-mobile" ref={nameRef} onClick={handleNameClick}>{displayName}</div>
              <div class="charinfo-mobile" >L{data.myLevel} {data.myClass}</div>
          </div>

          <div class="charimage-mobile">
              { charImage && (
                <img
                  class="charPhoto-mobile"
                  src={ charImage }
                  alt=""
                  id={ "charPhoto-mobile" }
                  onError={ () => {
                    const fallback = process.env.PUBLIC_URL + '/img/char/random.jpg';
                    if (charImage !== fallback) setCharImage(fallback);
                  } }
                  style= {{
                    zIndex: '1050'
                  }} />
              ) }
          </div>

      </div>
    </>
  )
}

export default CharNameMobile;